import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { URLS } from '../config';
import { hooks } from '../hooks';
import { theme } from '../constants';
import { product } from '../product';
import { actions } from '../store/actions';
import { components } from '../components';
import { Card, Typography, Button, Tag, Row, Col, Divider } from 'antd';
import { GiftOutlined } from '@ant-design/icons';
import Loading from '../components/Loading';
const { Title, Text, Paragraph } = Typography;

export const Product: React.FC = () => {
  const location = useLocation();
  const item = location.state.item;
  const token = hooks.useAppSelector(state => state.auth.token);
  const [ProductDetailData, setProductDetailData] = useState<any>();

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${URLS.GET_PRODUCT_DETAIL}${item.id}/`,
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        },
      );

      const newProductDetail = response.data;
      setProductDetailData(newProductDetail);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getReviews = async () => {
    setIsLoading(true);
    try {
      const reviews = await axios
        .get(URLS.GET_REVIEWS)
        .then(res => res.data.reviews);

      setReviewsData(reviews);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  const modifiedItem = {
    ...ProductDetailData,
  };
  const dispatch = hooks.useAppDispatch();
  const navigate = useNavigate();
  const [reviewsData, setReviewsData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [activeIndex, setActiveIndex] = useState(0);

  const renderHeader = (): JSX.Element => {
    return <components.Header goBack={true} line={true} basket={true} />;
  };

  const renderCoverImage = (): JSX.Element | null => {
    if (!ProductDetailData?.image) return null;

    return (
      <div style={{ marginBottom: 22 }}>
        <img
          src={ProductDetailData.image}
          alt='Cover'
          style={{
            width: '100%',
            height: 350,
            objectFit: 'contain',
            backgroundColor: theme.colors.imageBackground,
          }}
        />
      </div>
    );
  };

  const renderIndicator = (): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: 20,
          borderBottom: `1px solid ${theme.colors.aliceBlue2}`,
          marginBottom: 20,
        }}
      >
        {item.images?.map((item: any, index: number) => {
          const isSelected = index === activeIndex;
          const indicatorStyle = {
            background: isSelected ? theme.colors.mainColor : '#E8EFF4',
            display: 'inline-block',
            width: 22,
            height: 6,
            margin: '0 5px',
            borderRadius: 6,
          };
          return <div style={indicatorStyle} key={index} />;
        })}
      </div>
    );
  };

  const renderNameWithButton = (): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          padding: '0 20px 0 20px',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <h3
          style={{
            ...theme.fonts.Mulish_700Bold,
            fontSize: 20,
            color: theme.colors.mainColor,
          }}
        >
          {item.name}
        </h3>
      </div>
    );
  };

  const renderPriceWithQuantity = (): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          marginBottom: 20,
          padding: '0 20px 0 20px',
          ...theme.flex.rowCenterSpaceBetween,
        }}
      >
        <div>تعداد در بسته بندی: تعداد در سفارش:</div>
        <div
          style={{
            ...theme.fonts.Mulish_600SemiBold,
            fontSize: 20,
            lineHeight: 1.5,
            color: theme.colors.mainColor,
          }}
        >
          تومان {ProductDetailData.price}
        </div>
        <product.ProductCounterInner item={modifiedItem} />
      </div>
    );
  };

  const renderDescription = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 40, padding: '0 20px 0 20px' }}>
        <h5
          style={{
            marginBottom: 14,
            ...theme.fonts.Mulish_600SemiBold,
            fontSize: 16,
            fontWeight: 600,
            color: theme.colors.mainColor,
          }}
        >
          توضیحات
        </h5>
        <p
          style={{
            margin: 0,
            marginBottom: 20,
            color: theme.colors.textColor,
            lineHeight: 1.7,
          }}
        >
          {ProductDetailData.description}
        </p>
      </div>
    );
  };

  const renderButtons = (): JSX.Element => {
    return (
      <>
        <components.Button
          title='به سبد خرید اضافه کنید'
          onClick={() => {
            dispatch(actions.addToCart(modifiedItem));
          }}
          containerStyle={{ marginBottom: 10, padding: '0 20px 0 20px' }}
        />
      </>
    );
  };

  const ProductPage = (): JSX.Element => {
    return (
      <div style={{ padding: 24, }}>
        <Card
  style={{ borderColor: 'rgb(177 177 177)' }}
  cover={
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img
            src={ProductDetailData.image}
            alt={ProductDetailData.title}
            style={{
              width: "80%",
              maxWidth: 180,
              height: "auto",
              maxHeight: 180,
              objectFit: "contain",
              borderRadius: 8,
              marginTop:20
            }}
          />
        </div>
      }
    >
          <Row gutter={[32, 16]}>
            {/* Wishlist آیکون */}
            <product.ProductInWishlist item={item} style={{
              position: 'absolute',
              margin: 10,
              left: 0,
              top: 0,
              zIndex: 3,
            }} />

            {/* تصویر محصول */}

            <Divider />
            {/* اطلاعات محصول */}
            <Col xs={24} md={10} className='mt-2'>
              <Title level={3} style={{ ...theme.fonts.Mulish_400Regular }}>
                {ProductDetailData.title}
              </Title>

              <Paragraph style={{ whiteSpace: 'pre-line' }}>
                {ProductDetailData.description}
              </Paragraph>

              <Divider />

              <div style={{ marginBottom: 16 }}>
                {ProductDetailData.off_percentage ? (
                  <>
                    <Text delete style={{ fontSize: 16, marginLeft: 8 }}>
                      {ProductDetailData.price.toLocaleString()} تومان  
                    </Text>
                    <Text strong type='danger' style={{ fontSize: 18 }}>
                      {ProductDetailData.off_price.toLocaleString()} تومان  
                    </Text>
                    <Tag color='red' style={{ marginRight: 8 }}>
                      {ProductDetailData.off_percentage} %
                    </Tag>
                  </>
                ) : (
                  <Text strong style={{ fontSize: 18 }}>
                    {ProductDetailData.price.toLocaleString()} تومان
                  </Text>
                )}
              </div>

              <Divider />
              <Text strong>
              <div 
                className="flex items-center gap-2 bg-white p-2 rounded border border-gray-200"
              >
                
                <span className="font-semibold text-gray-700">تعداد در بسته بندی:</span>
                <span>{ProductDetailData.number_packaging ?? 1} عدد</span>
              </div>
              <div 
                className="flex items-center gap-2 bg-white p-2 rounded border border-gray-200"
              >
                <span className="font-semibold text-gray-700"> برند:</span>
                <span>
                {item.brand?.title || "ندارد"}
                </span>
              </div>

              {/* {ProductDetailData.options.map((opt:any, index:any) => (
              <div 
                key={index} 
                className="flex items-center gap-2 bg-white p-2 rounded border border-gray-200"
              >
                
                <span className="font-semibold text-gray-700">{opt.option}:</span>
                <span>{opt.value} {opt.rep}</span>
              </div>
            ))} */}
              </Text>

              <div>
                {ProductDetailData.is_available ? (
                  <Tag color='green'>موجود در انبار</Tag>
                ) : (
                  <Tag color='volcano'>ناموجود</Tag>
                )}
              </div>
            </Col>

            {/* توضیحات کامل */}
            <Col span={24}>
              <Divider orientation='right' orientationMargin={50}>
                توضیحات بیشتر
              </Divider>
              <Paragraph>{ProductDetailData.description}</Paragraph>
            </Col>
          </Row>

          {/* دکمه‌ها */}
          <Row gutter={[16, 16]} justify="center" align="middle">
            <Col xs={24} sm={16}>
              <Button
                type='primary'
                disabled={!ProductDetailData.is_available}
                size='large'
                onClick={() => dispatch(actions.addToCart(modifiedItem))}
                block
              >
                افزودن به سبد خرید
              </Button>
            </Col>
            <Col xs={24} sm={8} style={{ display: 'flex', justifyContent: 'center' }}>
              <product.ProductCounterInner item={modifiedItem} />
            </Col>
          </Row>
        </Card>
      </div>

    );
  };

  const renderContent = (): JSX.Element => {
    if (isLoading || !ProductDetailData) return  <Loading/>;

    return <div style={{ padding: '0 0 20px 0' }}>{ProductPage()}</div>;
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
